import { Strings } from "common/utility/string/string"
import { CognitoUserSession } from "../cognito/model/CognitoUserSession"
import { LoginResult } from "./login-result"


export class ChangePasswordResult {

    public signInUserSession: CognitoUserSession | undefined

    public static createLoginResult(changePasswordResult: ChangePasswordResult): LoginResult{
        return new LoginResult(
            !!changePasswordResult.signInUserSession?.accessToken,
            changePasswordResult.signInUserSession?.idToken?.payload?.username,
            changePasswordResult.signInUserSession?.idToken?.payload?.email,
            Strings.Empty,
            changePasswordResult.signInUserSession?.accessToken?.jwtToken,
            changePasswordResult.signInUserSession?.idToken?.jwtToken,
            changePasswordResult.signInUserSession?.refreshToken?.token
        )
    }
}
